import React from "react";
import PropTypes from "prop-types";

import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormNumberInput from "Common/Custom/FormNumberInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const EditLaundryItemCostForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  fields,
  ProductOptions,
  TaskOptions
}) => {

  const optionConfig = {
    product_id: {
      list: ProductOptions,
      valueKey: "product_id",
      labelKey: "product_name"
    },
    task_id: {
      list: TaskOptions,
      valueKey: "task_id",
      labelKey: "task_name"
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>Update Laundry Item Cost</HeadingOne>}
    >
      {fields.map((field) => {

        // 🔹 Select
        if (field.type === "select") {
          return (
            <FormSelect key={field.name} field={field} value={values[field.name]} handleChange={handleChange}
              options={getSelectOptions(field.name, optionConfig)} error={errors[field.name]} />
          );
        }

        // 🔹 Default Text Input
        return (
          <FormInput key={field.name} field={field} value={values[field.name]} handleChange={handleChange}
            error={errors[field.name]} />
        );
      })}

      <FormSubmitButton label="Update" loading={loading} colSize="col-12" align="end" />
    </PageBody>
  );
};

EditLaundryItemCostForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

EditLaundryItemCostForm.defaultProps = {
  errors: {},
  loading: false,
};

export default EditLaundryItemCostForm;
